/**
 * Collection Variant Selector
 * Handles click events on product swatches in the collection grid,
 * updating the active swatch visually and modifying the hidden input
 * for the Add To Cart form to ensure the correct variant ID is submitted.
 */
document.addEventListener('DOMContentLoaded', () => {
    // 1. Get all swatches with the JS hook class
    const swatches = document.querySelectorAll('.js-variant-swatch');

    swatches.forEach(swatch => {
        const handleClick = (event) => {
            const target = event.currentTarget;

            // --- IMPORTANT: Check if the swatch is sold out/unavailable ---
            if (target.dataset.available === 'false') {
                // If the element has pointer-events: none in CSS, this should only fire on keyboard focus,
                // but it's a good safety check.
                console.log('Cannot select a sold-out variant. Click ignored.');
                return; // Stop execution if sold out
            }
            // --------------------------------------------------------
            
            // 2. Find the parent product card (the <li> element)
            const productCard = target.closest('.product-card-item');

            if (!productCard) {
                console.error('Could not find parent product card for swatch.');
                return;
            }

            // 3. Get the new variant ID from the data attribute
            const newVariantId = target.dataset.variantId;
            
            // 4. Find the hidden input field responsible for ATC
            // We search within the specific product card to scope the update
            const variantIdInput = productCard.querySelector('.product-variant-id');
            
            if (!variantIdInput) {
                console.error('Could not find hidden variant ID input for this product card.');
                return;
            }

            // 5. Update the hidden input value
            variantIdInput.value = newVariantId;
            
            // 6. Visually update the active swatch
            // Deselect all swatches for this product card
            const allSwatchesInCard = productCard.querySelectorAll('.js-variant-swatch');
            allSwatchesInCard.forEach(s => s.classList.remove('is-active'));
            
            // Select the clicked swatch
            target.classList.add('is-active');

            console.log(`Product ID ${productCard.dataset.productId}: Variant selected: ${newVariantId}`);
        };

        // Add event listeners
        swatch.addEventListener('click', handleClick);

        // Handle keyboard interaction for accessibility (and respect sold-out state)
        swatch.addEventListener('keydown', (event) => {
            if ((event.key === 'Enter' || event.key === ' ') && swatch.dataset.available === 'true') {
                event.preventDefault(); // Prevent default action (e.g., scrolling for spacebar)
                handleClick(event);
            }
        });
    });
});